module.exports = __webpack_public_path__ + "static/media/ITCFranklinGothicStd-Demi.1e9ac7d1.ttf";